import React from "react";
import { useSlate } from "slate-react";

import { useEditorPopupContext } from "../../../contexts/editorPopupsContext";
import { LinkIcon } from "../../icons";
import { Helpers } from "../helpers";
import { NodeTypes } from "../slateTypes";

const LinkButton: React.FC = () => {
  const editor = useSlate();
  const { setUrl } = useEditorPopupContext();
  const isCodeActive = Helpers.isElement(editor, NodeTypes.BLOCK_CODE);
  return (
    <button
      id="linkButton"
      className={`editor-toolbar__button `}
      onMouseDown={event => {
        event.preventDefault();
        Helpers.prepareLink(editor, setUrl);
      }}
      disabled={isCodeActive}
    >
      <LinkIcon />
    </button>
  );
};

export { LinkButton };
